import { useEffect } from "react";
import { Skeleton } from "antd";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { CategoriasList } from "@/hooks/useCategorias";
import { useListaEmpresasMutation, useListaEmpresaByCategoria } from "@/hooks/useEmpresas";
import { useMachine } from "@/_zustand/machine";
import { homeStore } from "@/_zustand/home";

export const Categories = () => {
  const { clearMachine } = useMachine();
  const { clearAll, categoryId, setCategory } = homeStore();
  const categorias = CategoriasList();
  const { mutateAsync: empresasMutateAsync } = useListaEmpresasMutation();
  const empresasByCategory = useListaEmpresaByCategoria();

  useEffect(() => {
    if(!categoryId){
      empresasMutateAsync();
    }
    // Solo debe correr al montar, para cargar el estado inicial; categoryId
    // ya se maneja vía handleSetCategory, así que se excluye a propósito de
    // las deps para no re-disparar esto cuando el usuario cambia de categoría.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresasMutateAsync]);

  const handleSetCategory = async (id) => {
    if (categoryId === id) {
      return;
    }
    
    clearMachine();
    clearAll();
    setCategory(id);

    if(id == 1){
      empresasMutateAsync();
      return;
    }
    empresasByCategory.mutateAsync(id);
  };

  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div id="categories" className="container-fluid categories-transform ">
      <div className="container ">
        {/* <h2 id="categorias" className="col-12 text-center prompt-bold text-black fs-1 my-3" >
          Categorías
        </h2> */}
        <div className="justify-content-center flex-wrap oval-container oval-container--categorias">
          <Skeleton loading={categorias.isFetching} paragraph={{ rows: 1 }} title={false}>
            <Slider {...settings}>
              {categorias.data ? (
                categorias.data.map((categoria) => (
                  <div key={categoria.categoria_id}
                    className="card caja_categoria"
                    onClick={() => handleSetCategory(categoria.categoria_id)}
                  >
                    <img src={categoria.categoria_foto} alt={categoria.categoria_nombre}
                      className="card-category-img"
                    />

                    <span className="font_category">{categoria.categoria_nombre}</span>
                  </div>
                ))
              ) : (
                <></>
              )}
            </Slider>
          </Skeleton>
        </div>
      </div>
    </div>
  );
};
